// @flow

import styled from "styled-components";

const Form = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.forms.padding};
  text-align: center;
`;

export default Form;



// WEBPACK FOOTER //
// ./src/common/form.js